import { ThemeProvider as EMOThemeProvider } from '@emotion/react';
import { ReactNode } from 'react';
import useCreateTheme from '@/hooks/useCreateTheme.ts';

interface ThemeProviderProps {
  children?: ReactNode;
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useCreateTheme();

  return <EMOThemeProvider theme={theme}>{children}</EMOThemeProvider>;
}
